module.exports = __webpack_public_path__ + "img/glogo296.afb15e08.png";